<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <div class="card">
          <div class="card-title primary white-text">
            <i class="material-icons icon">person</i>
            My Details
          </div>

          <div class="card-content">
            <div class="row mb-0">
              <div v-if="loadingList" class="progress">
                <div class="indeterminate"></div>
              </div>

              <div v-else>
                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Username:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.username }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Name:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.name }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Address:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.address }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>City:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.city }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Pincode:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.pincode }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>State:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.state }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Country:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.country }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Email:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.email }}
                    </div>
                  </div>
                </div>

                <div class="col s12">
                  <div class="row">
                    <div class="col s6 m3">
                      <b>Phone:</b>
                    </div>
                    <div class="col s6 m9">
                      {{ originalItem.phone }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-action">
            <a
              class="waves-effect waves-light btn mr-1 mb-1"
              @click="openDialogEdit"
              :disabled="loadingList"
            >
              <i class="material-icons left mr-1">edit</i>
              Edit Details
            </a>

            <a
              class="waves-effect waves-light btn primary mb-1"
              @click="openDialogPassword"
              :disabled="loadingList"
            >
              <i class="material-icons left mr-1">refresh</i>
              Change Password
            </a>
          </div>

          <div
            id="editModal"
            class="modal"
          >
            <div class="card mt-0 mb-0">
              <div class="card-title primary white-text">
                Edit My Details
              </div>

              <div class="card-content">
                <div class="row">
                  <div class="input-field col s12 m6">
                    <input
                      autofocus
                      type="text"
                      id="username"
                      v-model="editedItem.username"
                    >
                    <label for="username">Username</label>
                    <span class="helper-text red-text">{{ (formErrors.username !== '') ? formErrors.username : 'Used to login, along with password' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <input
                      type="text"
                      id="fullName"
                      v-model="editedItem.name"
                    >
                    <label for="fullName">Full Name</label>
                    <span class="helper-text red-text">{{ (formErrors.name !== '') ? formErrors.name : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <textarea
                      id="address"
                      v-model="editedItem.address"
                      class="materialize-textarea"
                    ></textarea>
                    <label for="address">Address</label>
                    <span class="helper-text red-text">{{ (formErrors.address !== '') ? formErrors.address : 'House / Flat no, Locality' }}</span>
                  </div>

                  <div class="col s12 m6">
                    <div class="row">
                      <div class="input-field col s12">
                        <input
                          type="text"
                          id="city"
                          v-model="editedItem.city"
                        >
                        <label for="city">City</label>
                        <span class="helper-text red-text">{{ (formErrors.city !== '') ? formErrors.city : '' }}</span>
                      </div>

                      <div class="input-field col s12">
                        <input
                          type="text"
                          id="pincode"
                          v-model="editedItem.pincode"
                        >
                        <label for="pincode">Pincode</label>
                        <span class="helper-text red-text">{{ (formErrors.pincode !== '') ? formErrors.pincode : '' }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="state"
                      v-model="editedItem.state"
                    >
                    <label for="state">State</label>
                    <span class="helper-text red-text">{{ (formErrors.state !== '') ? formErrors.state : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="country"
                      v-model="editedItem.country"
                    >
                    <label for="country">Country</label>
                    <span class="helper-text red-text">{{ (formErrors.country !== '') ? formErrors.country : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="email"
                      id="email"
                      v-model="editedItem.email"
                    >
                    <label for="email">Email</label>
                    <span class="helper-text red-text">{{ (formErrors.email !== '') ? formErrors.email : '' }}</span>
                  </div>

                  <div class="input-field col s12 m6">
                    <input
                      type="text"
                      id="phone"
                      v-model="editedItem.phone"
                    >
                    <label for="phone">Phone</label>
                    <span class="helper-text red-text">{{ (formErrors.phone !== '') ? formErrors.phone : '' }}</span>
                  </div>
                </div>
              </div>

              <div class="card-action">
                <a
                  class="waves-effect waves-light btn mr-1 grey lighten-3 black-text"
                  @click="closeDialogEdit"
                >
                  Cancel
                </a>

                <a
                  class="waves-effect waves-light btn success right"
                  :disabled="saveInProgress"
                  @click="saveForm"
                >
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <i v-if="!saveInProgress" class="material-icons left">check</i>
                  Save
                </a>
              </div>
            </div>
          </div>

          <div
            id="passwordModal"
            class="modal"
            style="max-width:500px;"
          >
            <div class="card mt-0 mb-0">
              <div class="card-title primary white-text">
                Reset Password
              </div>

              <div class="card-content">
                <div class="row">
                  <div class="input-field col s12">
                    <input
                      type="password"
                      id="oldPassword"
                      v-model="oldPassword"
                    >
                    <label for="oldPassword">Old Password</label>
                    <span class="helper-text red-text">{{ (formErrorOldPassword !== '') ? formErrorOldPassword : '' }}</span>
                  </div>

                  <div class="input-field col s12">
                    <input
                      type="password"
                      id="newPassword"
                      v-model="newPassword"
                    >
                    <label for="newPassword">New Password</label>
                    <span class="helper-text red-text">{{ (formErrorNewPassword !== '') ? formErrorNewPassword : '' }}</span>
                  </div>
                </div>
              </div>

              <div class="card-action">
                <a
                  class="waves-effect waves-light btn mr-1 brown darken-1 white-text"
                  :disabled="generateInProgress"
                  @click="generatePassword"
                >
                  <i class="material-icons left">autorenew</i>
                  Generate
                </a>

                <a
                  class="waves-effect waves-light btn success right"
                  :disabled="saveInProgress"
                  @click="resetPassword"
                >
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <i v-if="!saveInProgress" class="material-icons left">check</i>
                  Save
                </a>

                <a
                  class="waves-effect waves-light btn mr-1 grey lighten-3 black-text right"
                  @click="closeDialogPassword"
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonFunction from '@/utils/common'
// Import the API functions
import httpApi from '@/utils/api'

export default {
  data () {
    return {
      // Loading status for list of items
      loadingList: true,

      // Dialog active?
      dialogEdit: null,

      // Saving
      saveInProgress: false,

      // Initial form bound variables
      originalItem: {
        username: '',
        password: '',
        name: '',

        address: '',
        city: '',
        state: '',
        country: '',
        pincode: '',

        email: '',
        phone: '',
        sendOffers: '1'
      },

      // Form bound variables being edited
      editedItem: {
        username: '',
        password: '',
        name: '',

        address: '',
        city: '',
        state: '',
        country: '',
        pincode: '',

        email: '',
        phone: '',
        sendOffers: '1'
      },

      // Error holders for form fields
      formErrors: {
        username: null,
        password: null,
        name: null,
        address: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        email: null,
        phone: null
      },

      // Default error holders used to reset the form
      defaultFormErrors: {
        username: null,
        password: null,
        name: null,
        address: null,
        city: null,
        state: null,
        country: null,
        pincode: null,
        email: null,
        phone: null
      },

      // Password reset form
      dialogPassword: null,
      oldPassword: '',
      newPassword: '',
      passwordVisible: false,
      formErrorOldPassword: null,
      formErrorNewPassword: null,
      generateInProgress: false
    }
  },

  mounted () {
    // On load, get data from API and populate form
    // Make the API call
    httpApi.callWithToken({
      url: 'user',
      method: 'get'
    })
      .then((resp) => {
        // Deactivate the loading animation
        this.loadingList = false

        // Set the form values to the values of the selected item
        this.editedItem = Object.assign({}, resp.data)
        this.originalItem = Object.assign({}, resp.data)

        var elems = document.querySelectorAll('.modal')
        // eslint-disable-next-line
        var instances = M.Modal.init(elems)

        // eslint-disable-next-line
        this.dialogEdit = M.Modal.getInstance(document.getElementById('editModal'))
        // eslint-disable-next-line
        this.dialogPassword = M.Modal.getInstance(document.getElementById('passwordModal'))
      })
      // If an error occurs
      .catch((err) => {
        // Deactivate the loading animation
        this.loadingList = false

        // Show error
        this.$store.dispatch('SHOW_STATUS_MESSAGE', {
          color: 'error',
          message: err.message
        })
      })
  },

  methods: {
    // Add or edit a product
    saveForm () {
      // Show loading animation
      this.saveInProgress = true

      // Empty older errors
      this.formErrors = Object.assign({}, this.defaultFormErrors)

      // Setup the API data body - mostly the same for add and edit, except id
      let dataBody = {
        username: this.editedItem.username,
        name: this.editedItem.name,
        address: this.editedItem.address,
        city: this.editedItem.city,
        state: this.editedItem.state,
        country: this.editedItem.country,
        pincode: this.editedItem.pincode,
        email: this.editedItem.email,
        phone: this.editedItem.phone,
        sendOffers: this.editedItem.sendOffers
      }

      // Save to API
      httpApi.callWithToken({
        url: 'user',
        data: dataBody,
        method: 'put'
      })
        .then((resp) => {
          this.originalItem = Object.assign({}, this.editedItem)

          // Show success message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'success',
            message: resp.message
          })

          // Close and reset dialog
          this.closeDialogEdit()

          // Hide loading animation
          this.saveInProgress = false
        })
        .catch((err) => {
          // Hide loading animation
          this.saveInProgress = false

          // Empty older errors
          this.formErrors = Object.assign({}, this.defaultFormErrors)

          // Show new errors. Timeout required, else fails
          setTimeout(() => {
            let errors = Object.keys(err.data)
            errors.forEach((value, key) => {
              // Set error message
              this.formErrors[value] = err.data[value]
            })
          }, 100)

          // There could be multiple errors in an array. Convert to a string
          let errorString = Object.values(err.data)
          errorString = errorString.join(', ')

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: errorString
          })
        })
    },

    openDialogEdit () {
      this.dialogEdit.open()
      // eslint-disable-next-line
      M.updateTextFields()
    },

    // Reset the edit variables and close dialog
    closeDialogEdit () {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.originalItem)
      }, 300)
      this.dialogEdit.close()
    },

    openDialogPassword () {
      this.dialogPassword.open()
    },

    // Reset the edit variables and close dialog
    closeDialogPassword () {
      this.dialogPassword.close()
      setTimeout(() => {
        // Set default formErrors
        this.formErrorOldPassword = null
        this.formErrorNewPassword = null
        // Set default form fields
        this.oldPassword = ''
        this.newPassword = ''
      }, 300)
    },

    generatePassword () {
      // Activate loading animation
      this.generateInProgress = true

      // Generate random secure password
      this.newPassword = commonFunction.generatePassword(10)

      // Deactivate the loading animation
      this.generateInProgress = false
    },

    resetPassword () {
      // Activate loading animation
      this.saveInProgress = true

      let dataBody = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }

      // Save to API
      httpApi.callWithToken({
        url: 'user/pwd',
        data: dataBody,
        method: 'post'
      })
        .then((resp) => {
          // Deactivate the loading animation
          this.saveInProgress = false

          // Show success message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'success',
            message: resp.message
          })

          // Close and reset dialog
          this.closeDialogPassword()
        })
        .catch((err) => {
          // Deactivate the loading animation
          this.saveInProgress = false

          // Show new errors. Timeout required, else fails
          setTimeout(() => {
            // Set error message
            this.formErrorOldPassword = err.data['oldPassword']
            this.formErrorNewPassword = err.data['password']
          }, 100)

          // There could be multiple errors in an array. Convert to a string
          let errorString = Object.values(err.data)
          errorString = errorString.join(', ')

          // Show error message
          this.$store.dispatch('SHOW_STATUS_MESSAGE', {
            color: 'error',
            message: errorString
          })
        })
    }
  }
}
</script>
